import { render, staticRenderFns } from "./profile-pencil.vue?vue&type=template&id=5709ad61&"
import script from "./profile-pencil.vue?vue&type=script&lang=js&"
export * from "./profile-pencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5709ad61')) {
      api.createRecord('5709ad61', component.options)
    } else {
      api.reload('5709ad61', component.options)
    }
    module.hot.accept("./profile-pencil.vue?vue&type=template&id=5709ad61&", function () {
      api.rerender('5709ad61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/profile-pencil.vue"
export default component.exports